<template>
    <div class="loading-container">
        <div>
            <vue-lottie :options="defaultOptions"
                :height="height"
                :width="width"
                class="center-animation"
                @animCreated="handleAnimation"
            />
            <span>Loading...</span>
        </div>
    </div>
</template>

<script>
import VueLottie from '@/components/AnimLottie'
import * as animationData from '../assets/animations/face.json'

export default {
    components: {
        VueLottie
    },
    props: {
        width: {
            type: Number,
            default: 200
        },
        height: {
            type: Number,
            default: 140
        },
        options: {
            type: Object
        }
    },
    data () {
        return {
            defaultOptions: {
                animationData: animationData,
                autoplay: false,
                loop: false
            },
            animationSpeed: 1,
            animLoaded: false,
            animComplete: true,
        }
    },
    methods: {
        handleAnimation (anim) {
            this.anim = anim
            // console.log('ANIM', anim)
            this.animLoaded = true
            this.faceDazedLoop()
        },
        faceDazedLoop () {
            let firstFrame = 34
            let lastFrame = 75.5
            let frameRate = 25
            let time = parseInt(((lastFrame - firstFrame) / frameRate) * 1000)
            this.anim.playSegments([firstFrame, lastFrame], true) // dazed

            setTimeout(() => {
                this.faceDazedLoop()
            }, time);
        },

       
        // Helper Functions
        stop () {
            this.anim.stop()
        },
        play () {
            this.anim.play()
        },
        pause () {
            this.anim.pause()
        }
        // // Animation Event Listeners
        // enterFrame (e) {
        //     console.log('enterFrame', this.anim.currentFrame)
        //     // if (Math.round(this.anim.currentFrame) === 78) {
        //     //     this.anim.goToAndPlay(13, true)
        //     // }
        // },
        // complete (e) {
        //     this.animComplete = true
        //     this.faceReturnTransition = false
        //     console.log('complete', e)
        // },
        // loopComplete (e) {
        //     console.log('loopComplete', e)
        //     // this.stop()
        // },
        // segmentStart (e) {
        //     this.animComplete = false
        //     console.log('segmentStart', e)
        // },
        // config_ready (e) {
        //     console.log('config_ready', e)
        // },
        // data_ready (e) {
        //     console.log('data_ready', e)
        // },
        // loaded_images (e) {
        //     console.log('loaded_images', e)
        // },
        // DOMLoaded (e) {
        //     console.log('DOMLoaded', e)
        // },
        // destroy (e) {
        //     console.log('destroy', e)
        // }
    }
}
</script>

<style lang="scss" scoped>
    .loading-container {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;
        span {
            display: block;
            color: $white;
            text-align: center;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue